import { render } from "./ProjectSummarySection.vue?vue&type=template&id=1fbe02fc&scoped=true&ts=true"
import script from "./ProjectSummarySection.vue?vue&type=script&lang=ts"
export * from "./ProjectSummarySection.vue?vue&type=script&lang=ts"

import "./ProjectSummarySection.vue?vue&type=style&index=0&id=1fbe02fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbe02fc"]])

export default __exports__